// ============================================
// 藏干和十神合并显示组件
// ============================================

import { Grid, Typography, Stack } from "@mui/material";
import { grey } from "@mui/material/colors";
import { getCellColor, getIsYang } from "../StyleControl";
import { Fragment } from "react";

function getKey(name) {
  return name + Math.random() * 10000;
}

export default function CangGanShenRow({ data, dark }) {
  const name = data[0];
  let columns = data.length;

  return (
    <Grid
      container
      columns={columns}
      spacing={0}
      key={name}
      alignItems="flex-start"
      justifyContent="space-between"
      sx={{
        backgroundColor: dark && grey[100],
        minWidth: columns * 60, // 每列最小60px，确保可以横向滚动
      }}
    >
      {data.map((item, idx) => {
        let box = null;

        // 第一个元素是标题
        if (idx === 0) {
          const isTitle = item === name;
          const fontStyle = getIsYang(item) ? null : "italic";
          box = (
            <Typography
              align="center"
              color={getCellColor(name, item)}
              sx={{ fontStyle: isTitle ? null : fontStyle }}
            >
              {item}
            </Typography>
          );
        } else if (
          typeof item === "object" &&
          item.cangGan &&
          item.zhiShen
        ) {
          // 藏干和十神对象
          box = (
            <Stack direction="column" spacing={0} alignItems="center">
              {item.cangGan.map((cangGan, index) => {
                const zhiShen = item.zhiShen[index] || "";
                const fontStyle = getIsYang(cangGan) ? null : "italic";
                return (
                  <Stack
                    key={index}
                    direction="row"
                    spacing={0.5}
                    alignItems="center"
                  >
                    <Typography
                      align="center"
                      color={getCellColor(name, cangGan)}
                      sx={{ fontSize: 14, fontStyle }}
                    >
                      {cangGan}
                    </Typography>
                    <Typography
                      align="center"
                      sx={{ fontSize: 12, color: "#666" }}
                    >
                      {zhiShen}
                    </Typography>
                  </Stack>
                );
              })}
            </Stack>
          );
        } else {
          box = <Typography align="center">{item}</Typography>;
        }

        return (
          <Fragment key={idx}>
            <Grid
              size={1}
              key={getKey(name)}
              alignItems={"flex-start"}
              alignContent={"flex-start"}
            >
              {box}
            </Grid>
          </Fragment>
        );
      })}
    </Grid>
  );
}
